import { render } from "./S127604.vue?vue&type=template&id=08801854"
const script = {}
script.render = render

export default script